import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DailyRateService {

  constructor(
    private http: HttpClient
  ) { }

  /**
 * Get Daily Rate.
 * @param dailyRateRequest Daily Rate Request
 */
  getDailyRate(dailyRateRequest: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/Rate`;
    return this.http.post(url, dailyRateRequest);
  }

  /**
 * add Daily Rate
 */
  addDailyRate(saveObj: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/Rate/add`;
    return this.http.post(url, saveObj);
  }

  /**
 * Get Daily Rate by Seq No.
 * @param seqNo Seq No
 */
  getDailyRateDetail(seqNo: any): Promise<any> {
    const url = `${environment.logisticsApiUrl}/Rate/${seqNo}`;
    return this.http.get(url).toPromise();
  }

  updateDailyRate(updateObj: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/Rate/update`;
    return this.http.put(url, updateObj);
  }

  importDailyRateByExcel(file: any, facility: any, createUser: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/Rate/importDailyRate/`;

    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('facility', facility);
    formData.append('createUser', createUser);

    let response = this.http.post(url, formData);
    return response;
  }
}
